import React from 'react';
import {Box} from '@mui/material';
import Typography from '@mui/material/Typography';
import type {ThesaurusNode} from 'services/thesaurus/types';
import {ThesaurusNodeCode} from 'components/thesaurus';
import {useThesaurusEditStateContext} from '../contexts';

type Props = {
  node: ThesaurusNode;
};

export const ThesaurusNodeDetailsTitle: React.FC<Props> = ({node}) => {
  const {getDisplayCode} = useThesaurusEditStateContext();

  const code = getDisplayCode(node);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: '2px 0',
      }}>
      <ThesaurusNodeCode showAll code={code} />
      <Typography variant="h3" color={'primary'}>
        {node.label}
      </Typography>
    </Box>
  );
};
